<template>
  <div class="hidden items-center gap-4 md:flex">
    <LangField
      v-if="availableLocales.length > 1"
      :currentLang="currentLocale"
      :langs="availableLocales"
      @select="setLang"
    />

    <Button
      v-if="userToken"
      prefix_icon="ic-user"
      :c_style="{ type: 'text', style: 'A' }"
      :label="$t('common.titles.profile')"
      :link="{ path: paths.account.index }"
    />

    <div v-else class="flex items-center">
      <Button
        :label="$t('user.auth.titles.signin')"
        :c_style="{ type: 'text', style: 'A' }"
        :link="{ path: paths.login }"
      />
      <span class="font-medium"> / </span>
      <Button
        :label="$t('user.auth.titles.register')"
        :c_style="{ type: 'text', style: 'A' }"
        :link="{ path: paths.register }"
      />
    </div>

    <Button
      v-if="!!$features?.wishlist"
      prefix_icon="ic-favorite"
      :c_style="{ type: 'text', style: 'A' }"
      :label="$t('common.titles.wishlist')"
      :link="{ path: paths.wishList }"
    />

    <div id="desktop-button-group" class="relative">
      <CartButton
        :cart-items-no
        :path="paths.cart"
        @mouseleave="startCloseTimer"
        @mouseenter="handleShowCartQuickView"
      />

      <CartQuickView
        v-if="showCartQuickView"
        class="absolute end-0 top-12 z-20"
        @open="handelClearTimer"
        @close="showCartQuickView = false"
      />
    </div>
  </div>

  <div id="mobile-button-group" class="flex items-center gap-1 md:hidden">
    <IconButton
      name="ic-user"
      :c_style="{ type: 'ghost' }"
      :link="{ path: paths.account.index }"
    />
    <IconButton
      v-if="!!$features?.wishlist"
      name="ic-favorite"
      :c_style="{ type: 'ghost' }"
      :link="{ path: paths.wishList }"
    />

    <CartButton :cart-items-no :path="paths.cart" />
  </div>
</template>

<script lang="ts" setup>
import Button from "~/components/common/Atom/Button.vue";
import IconButton from "~/components/common/Atom/IconButton.vue";
import LangField from "~/components/common/Atom/LangField.vue";
import CartButton from "~/components/common/Molecule/CartButton.vue";
import { LazyCheckoutOrganismCartQuickView as CartQuickView } from "#components";
import paths from "~/constants/paths";
let closeTimeoutId: NodeJS.Timeout;

defineProps<{
  cartItemsNo: number | string;
  isUserAdmin?: boolean;
}>();

const { currentLocale, availableLocales, setLang } = useLocale();
const userToken = useCookie("hs-token");

const showCartQuickView = ref(false);

const handleShowCartQuickView = () => {
  handelClearTimer();
  showCartQuickView.value = true;
};

const startCloseTimer = () => {
  closeTimeoutId = setTimeout(() => {
    showCartQuickView.value = false;
  }, 220);
};

const handelClearTimer = () => clearTimeout(closeTimeoutId);
</script>
